import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FormFieldWithHint = ({ id, label, hint, value, onChange, placeholder }) => (
  <div className="space-y-2">
    <Label htmlFor={id} className="text-slate-300">{label}</Label>
    <Input
      id={id}
      data-testid={`article-${id}-input`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500"
    />
    <p className="text-slate-500 text-xs">{hint}</p>
  </div>
);

export default FormFieldWithHint;
